module.exports = __webpack_public_path__ + "img/icon_map_5_on_010.a786793c.png";